// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-outdatedBrowser-outdatedBrowser__container--3USiD"};